import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { CoreModule } from './core/core.module';
import { WorkInProgressComponent } from './work-in-progress/work-in-progress.component';
import { AppCommonModule } from './common/app-common.module';
import { DoctorServiceReportComponent } from './doctor-service-report/doctor-service-report.component';
import { ExternalRedirectComponent } from './external-redirect.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AuthenticationModuleImpl } from './core/authentication/authentication-module-impl.module';
import { AuthenticationServiceImpl } from './core/authentication/authentication-service-impl.service';
import {
  AuthenticationModule,
  AuthenticationService,
} from '@vsp/angular-core-libraries';
import { SpinnerService } from '@vsp/angular-core-libraries/authentication/spinner/spinner.service';
import { RouterEventsService } from '@vsp/angular-core-libraries/authentication/router-events/router-events.service';

@NgModule({
  declarations: [
    AppComponent,
    WorkInProgressComponent,
    DoctorServiceReportComponent,
    ExternalRedirectComponent,
  ],
  imports: [
    AuthenticationModuleImpl.forRoot(
      environment.oauthApiUrl,
      environment.openIdUrl,
      environment.oauthClientId,
      environment.oauthScopes,
      environment.oauthRedirectUrl
    ),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    CoreModule,
    AppCommonModule,
  ],
  providers: [
    AuthenticationService,
    AuthenticationServiceImpl,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
